/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TitleHero.vue?vue&type=template&id=54cef6c9"
import script from "./TitleHero.vue?vue&type=script&lang=js"
export * from "./TitleHero.vue?vue&type=script&lang=js"
import style0 from "./TitleHero.vue?vue&type=style&index=0&id=54cef6c9&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports